import { render, staticRenderFns } from "./lastYear.vue?vue&type=template&id=f6b5c3c6&scoped=true&"
import script from "./lastYear.vue?vue&type=script&lang=js&"
export * from "./lastYear.vue?vue&type=script&lang=js&"
import style0 from "./lastYear.vue?vue&type=style&index=0&id=f6b5c3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5c3c6",
  null
  
)

export default component.exports